(ns teamoesterreich.event-mode.core
  (:require
    [clojure.string :as str]
    [reagent-material-ui.components :as mui]
    [reagent.core :as r]                                    ;usage

    [teamoesterreich.config :as config]
    [teamoesterreich.util.helper :as h]
    [teamoesterreich.event-mode.event-page :as event-todos]
    [teamoesterreich.store :as store]

    [teamoesterreich.style.toe-material-style :as m-style]
    [teamoesterreich.text.get-text :as txt]

    [teamoesterreich.user-mode.profile.profile-documents :as p-documents]
    [teamoesterreich.user-mode.profile.profile-personal :as p-personal])

  (:import (goog.i18n DateTimeSymbols_de_AT)))


(defn app-bar []
  [mui/app-bar
   {:position "static"
    :style    {:backgroundColor "white" :width "100vw" :overflow "hidden" :borderLeft 0 :borderRight 0 :margin-right "0" :margin-left "0"}}
   [mui/toolbar
    {:style {:backgroundColor "white" :display "flex" :flexDirection "row" :paddingRight 0 :paddingLeft 0}}
    ;[:f> (js/console.log "use-media-query"  (mui/use-media-query "(min-width:600px)"))]
    [:div {:className "nav-left" :style {:textAlign "left"}}
     [:img {:className "logo"
            :src       "/custom/img/banner.png" :alt (txt/txt :core "Team")}]
     ]


    [:div {:className "nav-center" :style {:flex "1"}}
     [mui/typography {:className "build-info" :style {:color "black" :textAlign "left" :margin "20px 0 0 20px"}}
      (when config/TEST_MACHINE (str "Test Server Build: " config/BUILD_DATE))]]

    [:div {:className "nav-right" :style {:paddingRight "30px"}}
     [:a {:className "sub-logo rk" :href (txt/txt :core :combo_rk_link) :target "_blank"}
      [:img {:src (txt/txt :core :combo_rk) :alt (txt/txt :core "RK") :style {:paddingRight "10px"}}]]

     [:a {:className "sub-logo radio" :href (txt/txt :core :combo_radio_link) :target "_blank"}
      [:img {:src (txt/txt :core :combo_radio) :alt (txt/txt :core "RADIO") :style {}}]]]]
   ])

(defn main []
  (let [!loaded (r/cursor store/app-state [:loaded])
        !uid (r/cursor store/app-state [:firebase-uid])
        !load-error (r/cursor store/app-state [:load-error])
        !login-error (r/cursor store/app-state [:login-error])
        !actual-user (r/cursor store/app-state [:actual-user])
        !page (r/atom (case (str/replace js/location.pathname #"^/event/?" "")
                        "landing" :landing
                        "profile" :profile
                        "documents" :documents
                        :landing))
        switch-page (fn [page]
                      (reset! !page page)
                      (js/history.pushState nil nil (str "/event/" (name page))))
        event-uuid (h/get-query-param "uuid")
        ]
    (js/addEventListener "popstate" (fn [e]
                                      (reset! !page (case (str/replace js/location.pathname #"^/event/?" "")
                                                      "landing" :landing
                                                      "profile" :profile
                                                      "documents" :documents
                                                      :landing))))

    (fn []
      [:<>
       [mui/css-baseline]

       [(m-style/with-toe-styles app-bar)]
       [:div {:style {:minHeight "calc(100vh - 70px)"}}
        [:span {:style {:display "none"}} (str @!uid)]

        (if (and @!loaded (:user @!loaded) (:auth @!loaded) (:documents @!loaded))
          [:<>
           [:div
            [:h1
             "Einsatz Onboarding" [:br]
             (str
               (get-in @!actual-user [:name :title]) " "
               (get-in @!actual-user [:name :first]) " "
               (get-in @!actual-user [:name :last]))]
            (case @!page
              :landing [event-todos/get-it switch-page event-uuid]
              :profile [p-personal/get-it {:go-back #(switch-page :landing) :save-at-bottom true :show-languages false :show-open-location false}]
              :documents [p-documents/get-it {:go-back #(switch-page :landing)}])
            ]

           (when @!load-error
             [mui/dialog
              {:justifyContent "center"
               :fullWidth      true
               :maxWidth       "md"
               :open           (true? @!load-error)
               :onClose        #(reset! !load-error false)}
              [mui/dialog-title
               {:onClose #(reset! !load-error false)}
               "Fehler"]
              [mui/dialog-content
               [:div "Beim Laden der Seite ist ein Fehler aufgetreten."]
               ]]
             )

           (when @!login-error
             [mui/dialog
              {:justifyContent "center"
               :fullWidth      true
               :maxWidth       "md"
               :open           (true? @!login-error)
               :onClose        #(reset! !login-error false)}
              [mui/dialog-title
               {:onClose #(reset! !login-error false)}
               "Fehler"]
              [mui/dialog-content
               [:div "Beim Login ist ein Fehler aufgetreten."]
               ]]
             )
           ]

          [mui/paper
           [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40}]
           [:h3 (str (txt/txt :core "Lade dein Team Profil"))]
           ]
          )
        ]

       ])))


